import z from "zod";

export const ProjectBadgeValues = ["new", "hot", "offer", "luxury", "sold_out"] as const;
export const BadgesEnum = z.enum(ProjectBadgeValues);
export const TypeEnum = z.enum(["villa", "apartment", "commercial_shops"]);
export const GoalEnum = z.enum(["residential", "investment", "shops", "citizenship", "villa", "office", "apartment"]);
export const PaymentMethodEnum = z.enum(["cash", "installment"]);
export const ProjectStatusEnum = z.enum(["ready", "under_construction", "off_plan"]);
export const ProjectOrderByEnum = z.enum(["featured", "minPrice", "maxPrice", "minArea", "maxArea"]).optional();

export type Badge = z.infer<typeof BadgesEnum>;
export type Type = z.infer<typeof TypeEnum>;
export type Goal = z.infer<typeof GoalEnum>;
export type PaymentMethod = z.infer<typeof PaymentMethodEnum>;
export type ProjectStatus = z.infer<typeof ProjectStatusEnum>;
export type ProjectOrderBy = z.infer<typeof ProjectOrderByEnum>;

export function hasInstallmentPayment(payment: readonly PaymentMethod[] | null | undefined) {
  return payment?.includes("installment") ?? false;
}

export function normalizePaymentMethods(payment: readonly PaymentMethod[] | null | undefined): PaymentMethod[] {
  return hasInstallmentPayment(payment) ? ["cash", "installment"] : ["cash"];
}

export function normalizePaymentFilter(payment: readonly PaymentMethod[] | null | undefined): PaymentMethod[] | undefined {
  return hasInstallmentPayment(payment) ? ["installment"] : undefined;
}

const BadgeValues = [...ProjectBadgeValues] as [Badge, ...Badge[]];
const TypeValues = TypeEnum.options as [Type, ...Type[]];
const GoalValues = GoalEnum.options as [Goal, ...Goal[]];
const PaymentMethodValues = PaymentMethodEnum.options as [PaymentMethod, ...PaymentMethod[]];
const StatusValues = ProjectStatusEnum.options as [ProjectStatus, ...ProjectStatus[]];

export const ProjectValues = {
  badges: BadgeValues,
  type: TypeValues,
  goal: GoalValues,
  payment: PaymentMethodValues,
  status: StatusValues,
};

export const ProjectValueOptions = {
  badges: BadgeValues.map((v) => ({ label: v === "luxury" ? "Luxury" : v, value: v })),
  type: TypeValues.map((v) => ({ label: v, value: v })),
  goal: GoalValues.map((v) => ({ label: v, value: v })),
  payment: PaymentMethodValues.map((v) => ({ label: v, value: v })),
  status: StatusValues.map((v) => ({ label: v, value: v })),
};

/* ------------------------------------------------ Schema ------------------------------------------------ */

export const LocationSchema = z.object({ lat: z.number(), lng: z.number() });
